import { filter, find, includes, map } from "lodash";
import { useContextualFocuses } from "@radarly/core/context/use-cases";
import { getConfigurationFieldsFromWizardTemplate } from "@radarly/models/insight-pages/wizard/configuration";
import { WizardTemplate } from "@radarly/models/insight-pages/wizard/model";
import {
  WizardConfiguration,
  WizardPropertiesConfiguration,
} from "@radarly/models/insight-pages/wizard/model/configuration";
import { useWizardConfigurationForm } from "./useWizardConfigurationForm";

export type Configuration = Omit<WizardConfiguration, "color" | "fields"> & {
  query: number;
  queries: number[];
};

export function useWizardPropertiesConfiguration({
  template,
  configuration,
  updateConfiguration,
}: {
  template: WizardTemplate;
  configuration: WizardConfiguration;
  updateConfiguration: (
    configuration: Pick<WizardConfiguration, "title" | "period" | "fields">
  ) => void;
}) {
  const contextualFocuses = useContextualFocuses();
  const updateGlobalConfiguration = (configuration: Configuration) => {
    updateConfiguration({
      ...configuration,
      fields: {
        query: configuration.query
          ? find(contextualFocuses, { id: configuration.query })
          : null,
        queries: configuration.queries
          ? filter(contextualFocuses, ({ id }) =>
              includes(configuration.queries, id)
            )
          : null,
      },
    });
  };
  const wizardConfiguration: WizardPropertiesConfiguration =
    useWizardConfigurationForm<Configuration>(
      {
        title: configuration.title,
        query: configuration.fields.query
          ? configuration.fields.query.id
          : null,
        queries: map(configuration.fields.queries, "id"),
        period: configuration.period,
        description: configuration.description,
        locale: configuration.locale,
        timezone: configuration.timezone,
      },
      updateGlobalConfiguration,
      template
    );
  const globalFields = getConfigurationFieldsFromWizardTemplate(template);

  return {
    wizardConfiguration,
    globalFields,
  };
}
